<template>
  <div>
    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="150"
    >
    <FormItem label="语音类型" v-if="formValidate.id != 0">
        <RadioGroup v-model="formValidate.type" type="button">
        <Radio label="语音生成"></Radio>
        <Radio label="人工配音"></Radio>
        </RadioGroup>
    </FormItem>

    <FormItem label="语音类型" v-if="formValidate.type == '语音生成'">
        <RadioGroup v-model="formValidate.audio_type" type="button">
        <Radio label="语音模型"></Radio>
        <Radio label="辅助音频"></Radio>
        </RadioGroup>
    </FormItem>

      <FormItem label="请上传字幕文件" prop="srt_path" v-if="formValidate.srt_path != '' || this.formValidate.id == ''">
        <input type="file" accept=".srt"  @change="handleSrtFileChange" ref="srtRef"/>
        <label class="search-label">{{show_srt_path}}</label>
      </FormItem>

      <FormItem label="声音模型" prop="audio_model_id" v-if="formValidate.audio_type == '语音模型' && formValidate.type == '语音生成'">
        <Select v-model="formValidate.audio_model_id">
          <Option
            v-for="item in audioModelIds"
            :value="item.id"
            :key="item.id"
            >{{ item.name}}</Option
          >
        </Select>
      </FormItem>

      <FormItem label="请上传辅助音频文件" v-if="formValidate.audio_type == '辅助音频' && formValidate.type == '语音生成'" prop="audio_path">
        <input type="file" accept=".MP3,.mp3,.wav, .WAV"  @change="handleAudioFileChange" ref="audioRef"/>
      </FormItem>

      <FormItem label="请上传处理好的音频文件" v-if="formValidate.type == '人工配音'">
        <input type="file" accept=".MP3,.mp3,.wav"  @change="handleSourceFileChange" />
        <label class="search-label">{{show_source_path}}</label>
      </FormItem>
      
      <FormItem style="text-align: right">
        <Button @click="handleReset('formValidate')">重置</Button>
        <Button
          type="primary"
          @click="handleSubmit('formValidate')"
          style="margin-left: 8px"
          >提交</Button
        >
      </FormItem>
    </Form>

  </div>
</template>

<script>
import params from '../argu-page/params.vue'
import moment from 'moment';
const { v4: uuidv4 } = require('uuid');
import { getOssClient } from '@/api/ossClient';

export default {
  components: { params },
  props: {
    resetFlag: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: () => {}
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      classifyIds: [],
      tagIds:[],
      audioModelIds:[],
      show_source_path:'',
      show_video_path:'',
      show_audio_path:'',
      show_srt_path:'',
      formValidate: {
        id: '',
        type:'语音生成',
        audio_type:'语音模型',
        videoPath:'',
        audio_path:'',
        source_path:'',
        audio_model_id:'',
        srt_path:'',
        content:'',
      },
      ruleValidate: {
        srt_path: [
          {
            required: true,
            message: 'srt文件必须上传',
            trigger: 'blur'
          }
        ], audio_path: [
          {
            required: true,
            message: '辅助音频必须上传',
            trigger: 'blur'
          }
        ], audio_model_id: [
          {
            required: true,
            message: '语音模型必须选择',
            trigger: 'change'
          }
        ]
      }
    }
  },
  watch: {
    resetFlag (resetFlag) {
      this.handleReset('formValidate')
      // this.$refs.srtRef.value = ''
      // this.$refs.audioRef.value = ''
    }
  },
  methods: {

    setEditData(params){
      this.formValidate.id = params.id
      if (params.type == 0){
        this.formValidate.type = "语音生成"
      }else{
        this.formValidate.type = "人工配音"
      }
      this.formValidate.videoPath = params.video_path
      this.formValidate.source_path = params.source_path
      this.formValidate.audio_path = params.audio_path
      this.formValidate.srt_path = params.srt_path
      this.formValidate.audio_model_id = params.audio_model_id.toString()
      
      if (params.video_path != null){
          var video_path_array = params.video_path.split("/")
          this.show_video_path = video_path_array[video_path_array.length - 1]
        }

        if (params.source_path != null){
          var video_source_array = params.source_path.split("/")
          this.show_source_path = video_source_array[video_source_array.length - 1]
        }

        if (params.audio_path != null){
          var video_audio_array = params.audio_path.split("/")
          this.show_audio_path = video_audio_array[video_audio_array.length - 1]
        }

        if (params.srt_path != null){
          var srt_array = params.srt_path.split("/")
          this.show_srt_path = srt_array[srt_array.length - 1]
        }

    },async handleSrtFileChange(e){
      const file = e.target.files[0];
        if (!file) return;
        this.formValidate.srt_path = await this.uploadFile(file)

        if (this.formValidate.srt_path != null){
          var srt_array = this.formValidate.srt_path.split("/")
          this.show_srt_path = srt_array[srt_array.length - 1]
        }
    },
    async handleAudioFileChange(e){
      try {

        const file = e.target.files[0];
        if (!file) return;

        this.formValidate.audio_path = await this.uploadFile(file)
        if (this.formValidate.audio_path != null){
            var org_audio_array = this.formValidate.audio_path.split("/")
            this.show_audio_path = org_audio_array[org_audio_array.length - 1]
        }

      } catch (error) {
        this.$Message.error('上传失败');
      }
    },
    async handleSourceFileChange(e){

      try {
        const file = e.target.files[0];
        if (!file) return;

        this.formValidate.source_path =  await this.uploadFile(file)
        if (this.formValidate.source_path != null){
            var org_source_array = this.formValidate.source_path.split("/")
            this.show_source_path = org_source_array[org_source_array.length - 1]
          }
      } catch (error) {
        this.$Message.error('上传失败');
      }

    },  async handleVideoFileChange(e){
      try {
        const file = e.target.files[0];
        if (!file) return;

        this.formValidate.videoPath = await this.uploadFile(file)

        if (this.formValidate.videoPath != null){
            var org_video_array = this.formValidate.videoPath.split("/")
            this.show_video_path = org_video_array[org_video_array.length - 1]
        }
  
      } catch (error) {
        this.$Message.error('上传失败');
      }
    },async uploadFile(file){

        // 上传文件
        let currentDate = moment().format('YYYY-MM-DD');
        const uuid = uuidv4()
        // 上传文件
        var name = file.name.substring(file.name.lastIndexOf('.'))
        const client = await getOssClient();
        const result = await client.put('short_video/' + currentDate + "/covert_audio/" + uuid + name, file);
        if (result['res']['statusCode'] == 200){
          this.$Message.info('上传成功');
          console.info(result['res']['requestUrls'][0])
          return result['res']['requestUrls'][0]
        }else{
          this.$Message.error('上传失败');
        }
        return ""

    }, setAudioList (audioModelList) {
      var data = new Array()
      for (var i = 0; i < audioModelList.length; i++) {
        data[i] = { id: audioModelList[i].id.toString(), name: audioModelList[i].audio_name }
      }
      this.audioModelIds = data
    },
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$emit('on-ok', this.formValidate)
        } else {
          this.$Message.error('失败!')
        }
      })
    },
    handleReset (name) {
      this.$refs[name].resetFields()
    }
  }
}
</script>
